// Translations
import form from '../sections/form/translations/de'

// Translation: Two-factor authentication > Landing (German)
export default Object.freeze({
	sections: { form }
})
